/* eslint-disable n/handle-callback-err */
import { useState, useContext, createContext, useEffect } from "react"
import axios from "axios"

import { useNavigate } from "react-router-dom"
import { LogsInitContext } from "../LogsInitComponentesContext/LogsInitComponentesContext"
import { ConexaoServerContext } from "../ConexaoServerContext/ConexaoServerContext"

import { showNotify } from "../../Utils/Utils"

let inital_load = true
let url_server = ''

export const RequestOneContext = createContext()

export const RequestOneProvider = ({ children }) => {
    const { LogInit } = useContext(LogsInitContext)
    LogInit('RequestOneProvider', 'contexto')

    const { getConfigServer } = useContext(ConexaoServerContext)

    const localUser = JSON.parse(sessionStorage.getItem("o_mo_user")) || ""
    const [bothToken, setBothToken] = useState({
        token: localUser.token,
        token_exp: localUser.token_exp
    })

    // const [tokenReady, setTokenReady] = useState(false)
    const navigate = useNavigate()

    useEffect(() => {
        if (inital_load) {
            inital_load = false

            start()
            keep_alive_jwt()
        }
    }, [])

    const start = async () => {
        url_server = await get_url_server()
    }

    const get_url_server = async () => {
        let conection = await getConfigServer()

        let url = `http://${conection.ip}:${conection.porta_api}/monitoramento`
        return url
    }

    const requestOne = async (config_axios) => {
        // Verificar se veio por parâmetros a url e o method que são necessários
        if (!config_axios.url || !config_axios.method) {
            showNotify("error", "Faltam parâmetros necessários!")
            return false
        }

        /* faz um merge entre as configurações que vinheram e as configurações padrão, priorizando as que vinheram */
        const default_axios = await axios_default_setting()
        config_axios = merge_axios_data(default_axios, config_axios)
        const axios_conf_merge = Object.assign(default_axios, config_axios)
        /* ------------------------------------------------------------------------------------------------- */

        let reqResponse = ""
        await axios.request(axios_conf_merge)
            .then((response) => {
                reqResponse = response.data
            })
            .catch(async (error) => {
                /* Se o backend retornou token expirado, busca novo token e refaz a request pendente */
                reqResponse = false
                if (error.code === 'ERR_NETWORK') {
                    showNotify("error", "Erro ao se comunicar com nossos servidores, verifique sua conexão")
                } else if (error.code === "ECONNABORTED" && (error.message.indexOf("timeout of") != -1)) {
                    showNotify("error", "Nossos servidores demoraram muito para responder. Se o erro persistir informe o suporte")
                } else if (error.response && error.response.status == 401 && error.response.data.error == "Token expirado") {
                    const refresh = await refreshToken(error)
                    reqResponse = refresh.data
                } else if (error.response && error.response.status == 401 && error.response.data.error == "Token inválido") {
                    showNotify("warning", "Sua sessão expirou")
                    sessionStorage.removeItem('o_mo_user')
                    navigate('/login')
                } else {
                    if (error.response && error.response.status == 403) {
                        return
                    }
                    reqResponse = error
                }
            })

        return reqResponse
    }

    const refreshToken = async (error) => {
        let result = ""
        try {
            const token_exp = JSON.parse(sessionStorage.getItem("o_mo_user")).token_exp
            if (!token_exp) {
                await sessionStorage.removeItem('o_mo_user')
            }

            let default_axios = await axios_default_setting()
            let originalRequest = {
                url: error.config.url,
                method: error.config.method
            }

            if (error.config && error.config.data) {
                originalRequest.data = JSON.parse(error.config.data)
            }
            if (error.config && error.config.params) {
                originalRequest.params = JSON.parse(error.config.params)
            }

            let refreshParameters = {
                url: 'jwt/revalidation',
                method: 'POST',
                data: { token_exp }
            }
            refreshParameters = Object.assign(default_axios, refreshParameters)
            /* request do novo token */
            await axios.request(refreshParameters)
                .then(async (res) => {
                    try {
                        try {
                            let user = (JSON.parse(sessionStorage.getItem("o_mo_user")) || {})
                            user = { ...user, token: res.data.data.token, token_exp: res.data.data.token_exp }
                            sessionStorage.setItem("o_mo_user", JSON.stringify(user))
                            let new_default_axios = await axios_default_setting()
                            originalRequest = Object.assign(new_default_axios, originalRequest)

                            await setBothToken({ token: res.data.data.token, token_exp: res.data.data.token_exp })
                        } catch (error) {
                            console.log("Houve um erro inesperado ao tentar gravar o token", error)
                            showMsgErroPadrao()
                            sessionStorage.removeItem('o_mo_user')
                        }

                        /* Refaz a request que ficou pendente */
                        await axios.request(originalRequest)
                            .then((response) => {
                                result = response
                            })
                            .catch((error) => {
                                if (error && error.response && error.response.data && error.response.data.status != 401) {
                                    showMsgErroPadrao()
                                    console.log("Houve um erro ao refazer a requisição pendente: ", error)
                                }
                            })
                    } catch (error) {
                        sessionStorage.removeItem('o_mo_user')
                        console.log("Houve um erro inesperado no processo do token", error)
                        showMsgErroPadrao()
                        result = error
                    }
                })
                .catch((err) => {
                    console.log("Houve um erro ao tentar regerar o token", err)
                    sessionStorage.removeItem('o_mo_user')
                    result = err
                })
        } catch (err) {
            result = err
        }
        return result
    }

    const axios_default_setting = () => {
        const { token } = JSON.parse(sessionStorage.getItem("o_mo_user")) || ""
        const setting = {
            baseURL: url_server,
            timeout: 20000,
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
        return setting
    }

    const merge_axios_data = (default_axios, config_axios) => {
        if (config_axios.data && default_axios.data) {
            config_axios.data = Object.assign(default_axios.data, config_axios.data)
        }
        return config_axios
    }

    const showMsgErroPadrao = () => {
        showNotify("error", "Um erro ocorreu. Informe o suporte caso o erro persista")
    }

    const keep_alive_jwt = () => {
        const default_axios = axios_default_setting()
        let config_axios = {
            url: 'jwt/keep_alive',
            method: 'POST'
        }
        config_axios = merge_axios_data(default_axios, config_axios)
        const axios_conf_merge = Object.assign(default_axios, config_axios)
        axios.request(axios_conf_merge).then(msg => {
            // token ja é valido
            // setTokenReady(true)
        }).catch(e => {
            let storage = ''
            try {
                storage = sessionStorage.getItem("o_mo_user")
                storage = (storage ? JSON.parse(storage) : storage)
                if (!storage) {
                    // não foi localizado nenhum token no sessionStorage
                    navigate('/login')
                    return false
                }
            } catch (e) {
                // não foi localizado nenhum token no sessionStorage
                navigate('/login')
                return false
            }

            jwt_revalidation(storage)
        })
    }

    const jwt_revalidation = (storage) => {
        let refreshParameters = {
            url: 'jwt/revalidation',
            method: 'POST',
            data: { token: storage.token, token_exp: storage.token_exp }
        }
        const default_axios = axios_default_setting()
        refreshParameters = Object.assign(default_axios, refreshParameters)
        axios.request(refreshParameters).then(data => {
            storage.token_exp = data.data.token_exp
            storage.token = data.data.token
            sessionStorage.setItem('o_mo_user', JSON.stringify(storage))
            // setTokenReady(true)
        }).catch(e => {
            if (e.response && e.response.data && (e.response.data === 'Token inválido' || e.response.data === 'Token expirado')) {
                navigate('/login')
            }
        })
    }

    let value = { bothToken, requestOne }

    return (
        <RequestOneContext.Provider value={value}>
            <div>
                {children}
            </div>
        </RequestOneContext.Provider>
    )
}
